// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/fonts/Raleway-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/fonts/Raleway-Italic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/fonts/Raleway-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/fonts/Raleway-LightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/fonts/Raleway-ExtraLight.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/fonts/Raleway-ExtraLightItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/fonts/Raleway-Thin.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/fonts/Raleway-ThinItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/fonts/Raleway-Medium.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../../assets/fonts/Raleway-MediumItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../../assets/fonts/Raleway-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../../assets/fonts/Raleway-BoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../../assets/fonts/Raleway-ExtraBold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../../assets/fonts/Raleway-ExtraBoldItalic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../../assets/fonts/Raleway-Black.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../../assets/fonts/Raleway-BlackItalic.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: AdminFontRegular;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: AdminFontItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: AdminFontLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
@font-face {
  font-family: AdminFontLightItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype");
}
@font-face {
  font-family: AdminFontExtraLight;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
}
@font-face {
  font-family: AdminFontExtraLightItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
}
@font-face {
  font-family: AdminFontThin;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("truetype");
}
@font-face {
  font-family: AdminFontThinItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("truetype");
}
@font-face {
  font-family: AdminFontMedium;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype");
}
@font-face {
  font-family: AdminFontMediumItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("truetype");
}
@font-face {
  font-family: AdminFontBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("truetype");
}
@font-face {
  font-family: AdminFontBoldItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("truetype");
}
@font-face {
  font-family: AdminFontExtraBold;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("truetype");
}
@font-face {
  font-family: AdminFontExtraBoldItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("truetype");
}
@font-face {
  font-family: AdminFontBlack;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype");
}
@font-face {
  font-family: AdminFontBlackItalic;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("truetype");
}
body {
  margin: 0px !important;
  font-family: AdminFontMedium;
}

#admin-header a {
  text-decoration: none;
  color: #1A1B25;
}
#admin-header .active {
  color: #fff;
  background-color: rgb(80, 70, 228);
  border-radius: 100px;
}
#admin-header a:not(.active):hover {
  background-color: #F6F8FA;
  border-radius: 100px;
}
#admin-header .first-menu, #admin-header .second-menu {
  padding: 0px 10px;
  border-bottom: 1px solid #eee;
  display: flex;
  align-items: center;
}
#admin-header .first-menu {
  background-color: #F6F8FA;
  height: 44px;
}
#admin-header .first-menu .MuiGrid-item {
  padding: 0px 8px;
}
#admin-header .first-menu .MuiGrid-item:last-child {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
#admin-header .first-menu #logo {
  max-height: 32px;
}
#admin-header .second-menu {
  height: 40px;
}
#admin-header .second-menu a {
  padding: 3px 10px;
  font-size: 14px;
}
#admin-header .second-menu .MuiGrid-item {
  padding: 8px 0px;
}
#admin-header .second-menu .MuiGrid-item:first-child {
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
}
#admin-header .second-menu .MuiGrid-item:last-child {
  text-align: end;
}
#admin-header .menu-account {
  display: flex;
  justify-content: flex-end;
}
#admin-header .menu-account .MuiButtonBase-root {
  padding: 0px;
}
#admin-header .menu-account .MuiButtonBase-root .MuiListItemIcon-root {
  display: flex;
  justify-content: flex-end;
}

#fade-menu .menu-name {
  padding: 6px 16px 10px;
  border-bottom: 1px solid #eee;
}
#fade-menu li {
  color: rgb(80, 70, 228);
  font-size: 14px;
}
#fade-menu li:hover {
  color: inherit;
}

a:active {
  color: inherit;
}

.MuiGrid-container {
  margin: auto;
}

#admin-content {
  padding: 32px 10px 0px 10px;
}
#admin-content .MuiGrid-container {
  padding: 0px 8px;
}
#admin-content h1 {
  margin-top: 0px;
  margin-bottom: 10px;
}
#admin-content #admin-menu-left h3 {
  margin-top: 0px;
  font-size: 16px;
}
#admin-content #admin-menu-left .menu-links {
  padding-bottom: 7px;
}
#admin-content #admin-menu-left .menu-links a {
  font-family: AdminFontRegular;
  color: #1A1B25;
  text-decoration: none;
  font-size: 14px;
  padding-top: 5px;
  padding-left: 12px;
  border-left: 1px solid #eee;
  padding-bottom: 7px;
}
#admin-content #admin-menu-left .menu-links .active {
  color: rgb(80, 70, 228);
  border-left: 2px solid #3e1952;
  font-family: AdminFontBold;
}
#admin-content .MuiInputBase-input:focus {
  color: rgb(80, 70, 228);
}

h1, h2, h3, h4, h5, h6 {
  font-family: AdminFontBold;
}

h1 {
  font-size: 28px;
}

.font-medium {
  font-family: AdminFontMedium !important;
}

.font-bold {
  font-family: AdminFontBold !important;
}

#admin-content > div > div.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.css-1idn90j-MuiGrid-root > div.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.css-17wqeb1-MuiGrid-root > div:nth-child(1) > div > a {
  margin-top: 0px !important;
}

#prov-form {
  font-size: 14px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  font-family: AdminFontRegular;
}
#prov-form input, #prov-form select, #prov-form textarea {
  font-size: 14px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #eee;
  font-family: AdminFontRegular;
}
#prov-form input::placeholder {
  font-size: 14px;
}
#prov-form .mb-12 {
  margin-bottom: 12px;
}
#prov-form h3 {
  font-size: 16px;
}
#prov-form button {
  padding: 8px 22px !important;
  border: none;
  background-color: rgb(80, 70, 228);
  color: #fff;
  font-family: AdminFontBold;
  border-radius: 6px !important;
  cursor: pointer;
}
#prov-form p {
  font-family: AdminFontBold;
  color: #c9c9c9;
}

.prov-form-select {
  font-size: 16px;
  padding: 4px 8px;
  border-radius: 6px;
  border: 1px solid #eee;
  font-family: AdminFontMedium;
}

.prov-button-div {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
}
.prov-button-div .prov-button {
  padding: 8px 22px !important;
  border: none;
  background-color: rgb(80, 70, 228);
  color: #fff;
  font-family: AdminFontBold;
  border-radius: 6px !important;
  cursor: pointer;
}

.MuiButton-containedPrimary {
  background-color: rgb(80, 70, 228) !important;
}

.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {
  color: rgb(80, 70, 228) !important;
}

.css-1aquho2-MuiTabs-indicator {
  background-color: rgb(80, 70, 228) !important;
}

.css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root.Mui-disabled {
  opacity: 0.2;
}

.table-title {
  font-size: 13px;
  font-family: AdminFontRegular;
}

.pagination {
  color: #1A1B25;
  width: 100%;
  letter-spacing: 1px;
  display: flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
  font-size: 14px;
  font-family: AdminFontRegular;
}
.pagination p {
  margin: 0px;
}
.pagination div {
  display: flex;
  align-items: center;
}
.pagination .pagination-buttons button {
  font-family: AdminFontMedium;
  border: 1px solid #c9c9c9;
  background-color: #fff;
  border-radius: 6px;
  padding: 6px 10px;
  cursor: pointer;
  letter-spacing: 1px;
  color: #1A1B25;
}
.pagination .pagination-buttons button:disabled {
  color: #c9c9c9;
  border: 1px solid #c9c9c9;
  background-color: #fff;
  cursor: default;
}

.MuiButton-contained.MuiButton-containedCancel {
  background-color: #f5f5f5 !important; /* gris clar */
  color: #333 !important; /* text gris fosc */
  border: 1px solid #dcdbdc !important;
  box-shadow: none !important;
}

.box-default {
  border: 1px solid #dcdbdc !important;
  border-radius: 5px;
}

/* BUTTON PRIMARY */
.MuiButton-containedPrimary {
  padding: 8px 22px !important;
  border-radius: 6px !important;
  color: #fff !important;
  background-color: rgb(80, 70, 228) !important;
  box-shadow: rgba(9, 30, 66, 0.12) 0px 1px 3px !important;
}

/* BUTTON SECONDARY */
.MuiButton-textSecondary {
  padding: 8px 22px !important;
  border-radius: 6px !important;
  color: rgba(0, 0, 0, 0.87) !important;
  background-color: transparent !important;
}

/* checked */
.MuiSwitch-colorPrimary.Mui-checked {
  color: rgb(80, 70, 228) !important;
}

.MuiSwitch-track {
  background: rgb(80, 70, 228) !important;
}

/* Link */
.MuiTypography-colorPrimary {
  color: rgb(80, 70, 228) !important;
}

/* Menu */
.MuiListItem-root.Mui-selected,
.MuiListItem-root.Mui-selected:hover {
  background: rgba(225, 221, 0, 0.2) !important;
}

.MuiListItem-root.MuiListItem-gutters:active {
  color: #000 !important;
}

.p-20 {
  padding: 20px;
}

.p-0 {
  padding: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mr-5px {
  margin-right: 5px;
}

.mt-2 {
  margin-top: 20px !important;
}

.ml-2 {
  margin-left: 20px;
}

.mr-2 {
  margin-right: 20px;
}

.mb-2 {
  margin-bottom: 20px !important;
}

.w-100 {
  width: 100% !important;
}

.MuiTableCell-head {
  font-size: 12px !important;
}

.alert-success {
  background-color: #3edb93;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px !important;
  color: #000;
}

.alert-danger {
  background-color: #ff5a5f;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px !important;
  color: #000;
}

a.MuiButtonBase-root:hover {
  color: #000 !important;
}

/* DASH background */
.css-fxbtpg {
  background-color: #f5f4f9 !important;
}

/* DASH background */
.css-fxbtpg {
  background-color: #f5f4f9 !important;
}

.dnd-element:first-child {
  background: #929292 !important;
}

/* TitTap Editor Design */
.ProseMirror {
  padding: 10px;
  border-top: 1px solid grey;
  background: white;
  border-radius: 0 0 5px 5px;
  min-height: 100px;
}

.ProseMirror:focus {
  border: none;
  outline: 1px solid aqua;
}

.ProseMirror > * + * {
  margin-top: 0.75em;
}

.ProseMirror ul,
.ProseMirror ol {
  padding: 0 2rem;
}

.ProseMirror h1,
.ProseMirror h2,
.ProseMirror h3,
.ProseMirror h4,
.ProseMirror h5,
.ProseMirror h6 {
  line-height: 1.1;
}

.ProseMirror code {
  background-color: rgba(97, 97, 97, 0.1);
  color: #616161;
}

.ProseMirror pre {
  background: #0d0d0d;
  color: #fff;
  font-family: "JetBrainsMono", monospace;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
}

.ProseMirror code {
  color: inherit;
  padding: 0;
  background: none;
  font-size: 0.8rem;
}

.ProseMirror img {
  max-width: 100%;
  height: auto;
}

.ProseMirror blockquote {
  padding-left: 1rem;
  border-left: 3px solid #999999;
}

.ProseMirror hr {
  border: none;
  border-top: 3px solid #999999;
  margin: 2rem 0;
}

/* ............................ */
.menuBar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
  border: 1px solid #bdbcbd;
  border-bottom: 0px;
}

.menuBar button {
  background-color: transparent;
  border: none;
  border-radius: 0.4rem;
  color: #0d0d0d;
  height: 1.75rem;
  margin-right: 0.25rem;
  padding: 0.25rem;
  width: 1.75rem;
  margin: 5px;
}

.menuBar button:hover {
  background: #000;
  color: #fff;
}

.heading3 {
  font-size: 15px;
}

button.is_active {
  background: #000;
  color: #fff;
}

.menuBar .divider {
  background-color: transparent;
  border: none;
  border-radius: 0.4rem;
  color: #0d0d0d;
  height: 1.75rem;
  margin-right: 0.25rem;
  padding: 0.25rem;
  width: 1.75rem;
  margin: 5px;
}

.ProseMirror {
  border: none;
}

.ProseMirror:focus {
  outline: 1px solid transparent;
}

h3.fields-title {
  padding: 0px 0px 20px 0px;
  margin: 0px 0px 20px 0px;
  border-bottom: 1px solid #c9c9c9;
  letter-spacing: 1px;
}`, "",{"version":3,"sources":["webpack://./src/scss/Admin/fonts.scss","webpack://./src/scss/Admin/index.scss","webpack://./src/scss/Admin/navbar.scss","webpack://./src/scss/Admin/colors.scss","webpack://./src/scss/Admin/content.scss","webpack://./src/scss/Admin/table.scss","webpack://./src/scss/Admin/btn.scss","webpack://./src/scss/Admin/dnd-element.scss","webpack://./src/scss/Admin/editor-text.scss","webpack://./src/scss/Admin/text.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADCA;EACI,4BAAA;EACA,+DAAA;ACCJ;ADCA;EACI,2BAAA;EACA,+DAAA;ACCJ;ADCA;EACI,iCAAA;EACA,+DAAA;ACCJ;ADCA;EACI,gCAAA;EACA,+DAAA;ACCJ;ADCA;EACI,sCAAA;EACA,+DAAA;ACCJ;ADCA;EACI,0BAAA;EACA,+DAAA;ACCJ;ADCA;EACI,gCAAA;EACA,+DAAA;ACCJ;ADCA;EACI,4BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,kCAAA;EACA,+DAAA;ACAJ;ADEA;EACI,0BAAA;EACA,gEAAA;ACAJ;ADGA;EACI,gCAAA;EACA,gEAAA;ACDJ;ADGA;EACI,+BAAA;EACA,gEAAA;ACDJ;ADIA;EACI,qCAAA;EACA,gEAAA;ACFJ;ADIA;EACI,2BAAA;EACA,gEAAA;ACFJ;ADKA;EACI,iCAAA;EACA,gEAAA;ACHJ;AC/DA;EACI,sBAAA;EACA,4BAAA;ADiEJ;;AC9DI;EACI,qBAAA;EACA,cAAA;ADiER;AC/DI;EACI,WCPO;EDQP,kCCXE;EDYF,oBAAA;ADiER;AC/DI;EACI,yBCEgB;EDDhB,oBAAA;ADiER;AC9DI;EACI,iBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;ADgER;AC7DI;EACI,yBCVgB;EDWhB,YAAA;AD+DR;AC7DQ;EACI,gBAAA;AD+DZ;AC5DQ;EACI,aAAA;EACA,yBAAA;EACA,mBAAA;AD8DZ;AC3DQ;EACI,gBAAA;AD6DZ;ACzDI;EACI,YAAA;AD2DR;ACzDQ;EACI,iBAAA;EACA,eAAA;AD2DZ;ACzDQ;EACI,gBAAA;AD2DZ;ACzDQ;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;AD2DZ;ACzDQ;EACI,eAAA;AD2DZ;ACvDI;EACI,aAAA;EACA,yBAAA;ADyDR;ACvDQ;EACI,YAAA;ADyDZ;ACxDY;EACI,aAAA;EACA,yBAAA;AD0DhB;;AClDI;EACI,sBAAA;EACA,6BAAA;ADqDR;AClDI;EACI,uBCpFS;EDqFT,eAAA;ADoDR;ACjDI;EACI,cAAA;ADmDR;;AC/CA;EACI,cAAA;ADkDJ;;AC/CA;EACI,YAAA;ADkDJ;;AC/CA;EACI,2BAAA;ADkDJ;AChDI;EACI,gBAAA;ADkDR;AC/CI;EACI,eAAA;EACA,mBAAA;ADiDR;AC7CQ;EACI,eAAA;EACA,eAAA;AD+CZ;AC5CQ;EACI,mBAAA;AD8CZ;AC5CY;EACI,6BAAA;EACA,cCzHJ;ED0HI,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;AD8ChB;AC3CY;EACI,uBCtIC;EDuID,8BAAA;EACA,0BAAA;AD6ChB;ACxCI;EACI,uBClJE;AF4LV;;ACtCA;EACI,0BAAA;ADyCJ;;ACtCA;EACI,eAAA;ADyCJ;;ACtCA;EACI,uCAAA;ADyCJ;;ACtCA;EACI,qCAAA;ADyCJ;;ACrCA;EACI,0BAAA;ADwCJ;;ACrCA;EACI,eAAA;EACA,aAAA;EACA,mBAAA;EACA,eAAA;EACA,8BAAA;EACA,6BAAA;ADwCJ;ACtCI;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,6BAAA;ADwCR;ACtCI;EACI,eAAA;ADwCR;ACtCI;EACI,mBAAA;ADwCR;ACtCI;EACI,eAAA;ADwCR;ACtCI;EACI,4BAAA;EACA,YAAA;EACA,kCCtME;EDuMF,WClMK;EDmML,0BAAA;EACA,6BAAA;EACA,eAAA;ADwCR;ACtCI;EACI,0BAAA;EACA,cCxMI;AFgPZ;;ACpCA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,sBAAA;EACA,4BAAA;ADuCJ;;ACpCA;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,uBAAA;ADuCJ;ACrCI;EACI,4BAAA;EACA,YAAA;EACA,kCCpOE;EDqOF,WChOK;EDiOL,0BAAA;EACA,6BAAA;EACA,eAAA;ADuCR;;ACpCA;EACI,6CAAA;ADuCJ;;AGnRA;EACI,kCAAA;AHsRJ;;AGpRA;EACI,6CAAA;AHuRJ;;AI3RA;EACI,YAAA;AJ8RJ;;AI3RA;EACI,eAAA;EACA,6BAAA;AJ8RJ;;AI3RA;EACI,cFHQ;EEIR,WAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,8BAAA;EACA,eAAA;EACA,6BAAA;AJ8RJ;AI5RI;EACI,WAAA;AJ8RR;AI3RI;EACI,aAAA;EACA,mBAAA;AJ6RR;AIzRQ;EACI,4BAAA;EACA,yBAAA;EACA,sBFlBO;EEmBP,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,cFhCA;AF2TZ;AIxRQ;EACI,cFrCA;EEsCA,yBAAA;EACA,sBF7BO;EE8BP,eAAA;AJ0RZ;;AKxUA;EACE,oCAAA,EAAA,cAAA;EACA,sBAAA,EAAA,mBAAA;EACA,oCAAA;EACA,2BAAA;AL2UF;;AKvUA;EACE,oCAAA;EACA,kBAAA;AL0UF;;AKvUA,mBAAA;AACA;EACE,4BAAA;EACA,6BAAA;EACA,sBAAA;EACA,6CAAA;EACA,wDAAA;AL0UF;;AKvUA,qBAAA;AACA;EACE,4BAAA;EACA,6BAAA;EACA,qCAAA;EACA,wCAAA;AL0UF;;AKvUA,YAAA;AACA;EACE,kCAAA;AL0UF;;AKvUA;EACE,uCAAA;AL0UF;;AKvUA,SAAA;AACA;EACE,kCAAA;AL0UF;;AKvUA,SAAA;AACA;;EAEE,6CAAA;AL0UF;;AKvUA;EACE,sBAAA;AL0UF;;AKvUA;EACE,aAAA;AL0UF;;AKvUA;EACE,uBAAA;AL0UF;;AKvUA;EACE,0BAAA;AL0UF;;AKvUA;EACE,iBAAA;AL0UF;;AKvUA;EACE,2BAAA;AL0UF;;AKvUA;EACE,iBAAA;AL0UF;;AKvUA;EACE,kBAAA;AL0UF;;AKvUA;EACE,8BAAA;AL0UF;;AKvUA;EACE,sBAAA;AL0UF;;AKvUA;EACE,0BAAA;AL0UF;;AKvUA;EACE,yBHxEQ;EGyER,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AL0UF;;AKvUA;EACE,yBH/EO;EGgFP,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,WAAA;AL0UF;;AKvUA;EACE,sBAAA;AL0UF;;AKvUA,oBAAA;AACA;EACE,oCAAA;AL0UF;;AKvUA,oBAAA;AACA;EACE,oCAAA;AL0UF;;AMncA;EACE,8BAAA;ANscF;;AOvcA,yBAAA;AACA;EACE,aAAA;EACA,0BAAA;EACA,iBAAA;EACA,0BAAA;EACA,iBAAA;AP0cF;;AOxcA;EACE,YAAA;EACA,uBAAA;AP2cF;;AOxcA;EACE,kBAAA;AP2cF;;AOxcA;;EAEE,eAAA;AP2cF;;AOxcA;;;;;;EAME,gBAAA;AP2cF;;AOxcA;EACE,uCAAA;EACA,cAAA;AP2cF;;AOxcA;EACE,mBAAA;EACA,WAAA;EACA,uCAAA;EACA,qBAAA;EACA,qBAAA;AP2cF;;AOzcA;EACE,cAAA;EACA,UAAA;EACA,gBAAA;EACA,iBAAA;AP4cF;;AOzcA;EACE,eAAA;EACA,YAAA;AP4cF;;AOzcA;EACE,kBAAA;EACA,8BAAA;AP4cF;;AOzcA;EACE,YAAA;EACA,6BAAA;EACA,cAAA;AP4cF;;AOzcA,iCAAA;AAEA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,6BAAA;EACA,4BAAA;EACA,yBAAA;EACA,kBAAA;AP2cF;;AOzcA;EACE,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AP4cF;;AOzcA;EACE,gBAAA;EACA,WAAA;AP4cF;;AOzcA;EACE,eAAA;AP4cF;;AOzcA;EACE,gBAAA;EACA,WAAA;AP4cF;;AOzcA;EACE,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AP4cF;;AO1cA;EACE,YAAA;AP6cF;;AO3cA;EACE,8BAAA;AP8cF;;AQlkBA;EACE,yBAAA;EACA,wBAAA;EACA,gCAAA;EACA,mBAAA;ARqkBF","sourcesContent":["@font-face {\n    font-family: AdminFontRegular;\n    src: url('../../assets/fonts/Raleway-Regular.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontItalic;\n    src: url('../../assets/fonts/Raleway-Italic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontLight;\n    src: url('../../assets/fonts/Raleway-Light.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontLightItalic;\n    src: url('../../assets/fonts/Raleway-LightItalic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontExtraLight;\n    src: url('../../assets/fonts/Raleway-ExtraLight.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontExtraLightItalic;\n    src: url('../../assets/fonts/Raleway-ExtraLightItalic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontThin;\n    src: url('../../assets/fonts/Raleway-Thin.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontThinItalic;\n    src: url('../../assets/fonts/Raleway-ThinItalic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontMedium;\n    src: url('../../assets/fonts/Raleway-Medium.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: AdminFontMediumItalic;\n    src: url('../../assets/fonts/Raleway-MediumItalic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontBold;\n    src: url('../../assets/fonts/Raleway-Bold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: AdminFontBoldItalic;\n    src: url('../../assets/fonts/Raleway-BoldItalic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontExtraBold;\n    src: url('../../assets/fonts/Raleway-ExtraBold.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: AdminFontExtraBoldItalic;\n    src: url('../../assets/fonts/Raleway-ExtraBoldItalic.ttf') format('truetype');\n}\n@font-face {\n    font-family: AdminFontBlack;\n    src: url('../../assets/fonts/Raleway-Black.ttf') format('truetype');\n}\n\n@font-face {\n    font-family: AdminFontBlackItalic;\n    src: url('../../assets/fonts/Raleway-BlackItalic.ttf') format('truetype');\n}","@font-face {\n  font-family: AdminFontRegular;\n  src: url(\"../../assets/fonts/Raleway-Regular.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontItalic;\n  src: url(\"../../assets/fonts/Raleway-Italic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontLight;\n  src: url(\"../../assets/fonts/Raleway-Light.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontLightItalic;\n  src: url(\"../../assets/fonts/Raleway-LightItalic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontExtraLight;\n  src: url(\"../../assets/fonts/Raleway-ExtraLight.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontExtraLightItalic;\n  src: url(\"../../assets/fonts/Raleway-ExtraLightItalic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontThin;\n  src: url(\"../../assets/fonts/Raleway-Thin.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontThinItalic;\n  src: url(\"../../assets/fonts/Raleway-ThinItalic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontMedium;\n  src: url(\"../../assets/fonts/Raleway-Medium.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontMediumItalic;\n  src: url(\"../../assets/fonts/Raleway-MediumItalic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontBold;\n  src: url(\"../../assets/fonts/Raleway-Bold.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontBoldItalic;\n  src: url(\"../../assets/fonts/Raleway-BoldItalic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontExtraBold;\n  src: url(\"../../assets/fonts/Raleway-ExtraBold.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontExtraBoldItalic;\n  src: url(\"../../assets/fonts/Raleway-ExtraBoldItalic.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontBlack;\n  src: url(\"../../assets/fonts/Raleway-Black.ttf\") format(\"truetype\");\n}\n@font-face {\n  font-family: AdminFontBlackItalic;\n  src: url(\"../../assets/fonts/Raleway-BlackItalic.ttf\") format(\"truetype\");\n}\nbody {\n  margin: 0px !important;\n  font-family: AdminFontMedium;\n}\n\n#admin-header a {\n  text-decoration: none;\n  color: #1A1B25;\n}\n#admin-header .active {\n  color: #fff;\n  background-color: rgb(80, 70, 228);\n  border-radius: 100px;\n}\n#admin-header a:not(.active):hover {\n  background-color: #F6F8FA;\n  border-radius: 100px;\n}\n#admin-header .first-menu, #admin-header .second-menu {\n  padding: 0px 10px;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  align-items: center;\n}\n#admin-header .first-menu {\n  background-color: #F6F8FA;\n  height: 44px;\n}\n#admin-header .first-menu .MuiGrid-item {\n  padding: 0px 8px;\n}\n#admin-header .first-menu .MuiGrid-item:last-child {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}\n#admin-header .first-menu #logo {\n  max-height: 32px;\n}\n#admin-header .second-menu {\n  height: 40px;\n}\n#admin-header .second-menu a {\n  padding: 3px 10px;\n  font-size: 14px;\n}\n#admin-header .second-menu .MuiGrid-item {\n  padding: 8px 0px;\n}\n#admin-header .second-menu .MuiGrid-item:first-child {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n}\n#admin-header .second-menu .MuiGrid-item:last-child {\n  text-align: end;\n}\n#admin-header .menu-account {\n  display: flex;\n  justify-content: flex-end;\n}\n#admin-header .menu-account .MuiButtonBase-root {\n  padding: 0px;\n}\n#admin-header .menu-account .MuiButtonBase-root .MuiListItemIcon-root {\n  display: flex;\n  justify-content: flex-end;\n}\n\n#fade-menu .menu-name {\n  padding: 6px 16px 10px;\n  border-bottom: 1px solid #eee;\n}\n#fade-menu li {\n  color: rgb(80, 70, 228);\n  font-size: 14px;\n}\n#fade-menu li:hover {\n  color: inherit;\n}\n\na:active {\n  color: inherit;\n}\n\n.MuiGrid-container {\n  margin: auto;\n}\n\n#admin-content {\n  padding: 32px 10px 0px 10px;\n}\n#admin-content .MuiGrid-container {\n  padding: 0px 8px;\n}\n#admin-content h1 {\n  margin-top: 0px;\n  margin-bottom: 10px;\n}\n#admin-content #admin-menu-left h3 {\n  margin-top: 0px;\n  font-size: 16px;\n}\n#admin-content #admin-menu-left .menu-links {\n  padding-bottom: 7px;\n}\n#admin-content #admin-menu-left .menu-links a {\n  font-family: AdminFontRegular;\n  color: #1A1B25;\n  text-decoration: none;\n  font-size: 14px;\n  padding-top: 5px;\n  padding-left: 12px;\n  border-left: 1px solid #eee;\n  padding-bottom: 7px;\n}\n#admin-content #admin-menu-left .menu-links .active {\n  color: rgb(80, 70, 228);\n  border-left: 2px solid #3e1952;\n  font-family: AdminFontBold;\n}\n#admin-content .MuiInputBase-input:focus {\n  color: rgb(80, 70, 228);\n}\n\nh1, h2, h3, h4, h5, h6 {\n  font-family: AdminFontBold;\n}\n\nh1 {\n  font-size: 28px;\n}\n\n.font-medium {\n  font-family: AdminFontMedium !important;\n}\n\n.font-bold {\n  font-family: AdminFontBold !important;\n}\n\n#admin-content > div > div.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.css-1idn90j-MuiGrid-root > div.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.css-17wqeb1-MuiGrid-root > div:nth-child(1) > div > a {\n  margin-top: 0px !important;\n}\n\n#prov-form {\n  font-size: 14px;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  font-family: AdminFontRegular;\n}\n#prov-form input, #prov-form select, #prov-form textarea {\n  font-size: 14px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: 1px solid #eee;\n  font-family: AdminFontRegular;\n}\n#prov-form input::placeholder {\n  font-size: 14px;\n}\n#prov-form .mb-12 {\n  margin-bottom: 12px;\n}\n#prov-form h3 {\n  font-size: 16px;\n}\n#prov-form button {\n  padding: 8px 22px !important;\n  border: none;\n  background-color: rgb(80, 70, 228);\n  color: #fff;\n  font-family: AdminFontBold;\n  border-radius: 6px !important;\n  cursor: pointer;\n}\n#prov-form p {\n  font-family: AdminFontBold;\n  color: #c9c9c9;\n}\n\n.prov-form-select {\n  font-size: 16px;\n  padding: 4px 8px;\n  border-radius: 6px;\n  border: 1px solid #eee;\n  font-family: AdminFontMedium;\n}\n\n.prov-button-div {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: center;\n}\n.prov-button-div .prov-button {\n  padding: 8px 22px !important;\n  border: none;\n  background-color: rgb(80, 70, 228);\n  color: #fff;\n  font-family: AdminFontBold;\n  border-radius: 6px !important;\n  cursor: pointer;\n}\n\n.MuiButton-containedPrimary {\n  background-color: rgb(80, 70, 228) !important;\n}\n\n.css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected {\n  color: rgb(80, 70, 228) !important;\n}\n\n.css-1aquho2-MuiTabs-indicator {\n  background-color: rgb(80, 70, 228) !important;\n}\n\n.css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root.Mui-disabled {\n  opacity: 0.2;\n}\n\n.table-title {\n  font-size: 13px;\n  font-family: AdminFontRegular;\n}\n\n.pagination {\n  color: #1A1B25;\n  width: 100%;\n  letter-spacing: 1px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  flex-wrap: nowrap;\n  justify-content: space-between;\n  font-size: 14px;\n  font-family: AdminFontRegular;\n}\n.pagination p {\n  margin: 0px;\n}\n.pagination div {\n  display: flex;\n  align-items: center;\n}\n.pagination .pagination-buttons button {\n  font-family: AdminFontMedium;\n  border: 1px solid #c9c9c9;\n  background-color: #fff;\n  border-radius: 6px;\n  padding: 6px 10px;\n  cursor: pointer;\n  letter-spacing: 1px;\n  color: #1A1B25;\n}\n.pagination .pagination-buttons button:disabled {\n  color: #c9c9c9;\n  border: 1px solid #c9c9c9;\n  background-color: #fff;\n  cursor: default;\n}\n\n.MuiButton-contained.MuiButton-containedCancel {\n  background-color: #f5f5f5 !important; /* gris clar */\n  color: #333 !important; /* text gris fosc */\n  border: 1px solid #dcdbdc !important;\n  box-shadow: none !important;\n}\n\n.box-default {\n  border: 1px solid #dcdbdc !important;\n  border-radius: 5px;\n}\n\n/* BUTTON PRIMARY */\n.MuiButton-containedPrimary {\n  padding: 8px 22px !important;\n  border-radius: 6px !important;\n  color: #fff !important;\n  background-color: rgb(80, 70, 228) !important;\n  box-shadow: rgba(9, 30, 66, 0.12) 0px 1px 3px !important;\n}\n\n/* BUTTON SECONDARY */\n.MuiButton-textSecondary {\n  padding: 8px 22px !important;\n  border-radius: 6px !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  background-color: transparent !important;\n}\n\n/* checked */\n.MuiSwitch-colorPrimary.Mui-checked {\n  color: rgb(80, 70, 228) !important;\n}\n\n.MuiSwitch-track {\n  background: rgb(80, 70, 228) !important;\n}\n\n/* Link */\n.MuiTypography-colorPrimary {\n  color: rgb(80, 70, 228) !important;\n}\n\n/* Menu */\n.MuiListItem-root.Mui-selected,\n.MuiListItem-root.Mui-selected:hover {\n  background: rgba(225, 221, 0, 0.2) !important;\n}\n\n.MuiListItem-root.MuiListItem-gutters:active {\n  color: #000 !important;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.mt-0 {\n  margin-top: 0px !important;\n}\n\n.mr-5px {\n  margin-right: 5px;\n}\n\n.mt-2 {\n  margin-top: 20px !important;\n}\n\n.ml-2 {\n  margin-left: 20px;\n}\n\n.mr-2 {\n  margin-right: 20px;\n}\n\n.mb-2 {\n  margin-bottom: 20px !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.MuiTableCell-head {\n  font-size: 12px !important;\n}\n\n.alert-success {\n  background-color: #3edb93;\n  padding: 20px;\n  margin-bottom: 20px;\n  border-radius: 6px !important;\n  color: #000;\n}\n\n.alert-danger {\n  background-color: #ff5a5f;\n  padding: 20px;\n  margin-bottom: 20px;\n  border-radius: 6px !important;\n  color: #000;\n}\n\na.MuiButtonBase-root:hover {\n  color: #000 !important;\n}\n\n/* DASH background */\n.css-fxbtpg {\n  background-color: #f5f4f9 !important;\n}\n\n/* DASH background */\n.css-fxbtpg {\n  background-color: #f5f4f9 !important;\n}\n\n.dnd-element:first-child {\n  background: #929292 !important;\n}\n\n/* TitTap Editor Design */\n.ProseMirror {\n  padding: 10px;\n  border-top: 1px solid grey;\n  background: white;\n  border-radius: 0 0 5px 5px;\n  min-height: 100px;\n}\n\n.ProseMirror:focus {\n  border: none;\n  outline: 1px solid aqua;\n}\n\n.ProseMirror > * + * {\n  margin-top: 0.75em;\n}\n\n.ProseMirror ul,\n.ProseMirror ol {\n  padding: 0 2rem;\n}\n\n.ProseMirror h1,\n.ProseMirror h2,\n.ProseMirror h3,\n.ProseMirror h4,\n.ProseMirror h5,\n.ProseMirror h6 {\n  line-height: 1.1;\n}\n\n.ProseMirror code {\n  background-color: rgba(97, 97, 97, 0.1);\n  color: #616161;\n}\n\n.ProseMirror pre {\n  background: #0d0d0d;\n  color: #fff;\n  font-family: \"JetBrainsMono\", monospace;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n}\n\n.ProseMirror code {\n  color: inherit;\n  padding: 0;\n  background: none;\n  font-size: 0.8rem;\n}\n\n.ProseMirror img {\n  max-width: 100%;\n  height: auto;\n}\n\n.ProseMirror blockquote {\n  padding-left: 1rem;\n  border-left: 3px solid #999999;\n}\n\n.ProseMirror hr {\n  border: none;\n  border-top: 3px solid #999999;\n  margin: 2rem 0;\n}\n\n/* ............................ */\n.menuBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border: 1px solid #bdbcbd;\n  border-bottom: 0px;\n}\n\n.menuBar button {\n  background-color: transparent;\n  border: none;\n  border-radius: 0.4rem;\n  color: #0d0d0d;\n  height: 1.75rem;\n  margin-right: 0.25rem;\n  padding: 0.25rem;\n  width: 1.75rem;\n  margin: 5px;\n}\n\n.menuBar button:hover {\n  background: #000;\n  color: #fff;\n}\n\n.heading3 {\n  font-size: 15px;\n}\n\nbutton.is_active {\n  background: #000;\n  color: #fff;\n}\n\n.menuBar .divider {\n  background-color: transparent;\n  border: none;\n  border-radius: 0.4rem;\n  color: #0d0d0d;\n  height: 1.75rem;\n  margin-right: 0.25rem;\n  padding: 0.25rem;\n  width: 1.75rem;\n  margin: 5px;\n}\n\n.ProseMirror {\n  border: none;\n}\n\n.ProseMirror:focus {\n  outline: 1px solid transparent;\n}\n\nh3.fields-title {\n  padding: 0px 0px 20px 0px;\n  margin: 0px 0px 20px 0px;\n  border-bottom: 1px solid #c9c9c9;\n  letter-spacing: 1px;\n}","body{\n    margin: 0px !important;\n    font-family: AdminFontMedium;\n}\n#admin-header{\n    a{\n        text-decoration: none;\n        color: $font-dark;\n    }\n    .active {\n        color: $font-primary;\n        background-color: $primary;\n        border-radius: 100px;\n    }\n    a:not(.active):hover{\n        background-color: $background-grey-light;\n        border-radius: 100px;\n    }\n\n    .first-menu, .second-menu{\n        padding: 0px 10px;\n        border-bottom: 1px solid $border-grey-light;\n        display: flex;\n        align-items: center;\n    }\n\n    .first-menu{\n        background-color: $background-grey-light;\n        height: 44px;\n        \n        .MuiGrid-item{\n            padding: 0px 8px;\n        }\n\n        .MuiGrid-item:last-child{\n            display: flex;\n            justify-content: flex-end;\n            align-items: center;\n        }\n\n        #logo{\n            max-height: 32px;\n        }\n    }\n\n    .second-menu{\n        height: 40px;\n\n        a{\n            padding: 3px 10px;\n            font-size: 14px;\n        }\n        .MuiGrid-item{\n            padding: 8px 0px;\n        }\n        .MuiGrid-item:first-child{\n            display: flex;\n            flex-direction: row;\n            align-items: center;\n            flex-wrap: nowrap;\n        }\n        .MuiGrid-item:last-child{\n            text-align: end;\n        }\n    }\n\n    .menu-account{\n        display: flex;\n        justify-content: flex-end;\n\n        .MuiButtonBase-root{\n            padding: 0px;\n            .MuiListItemIcon-root{\n                display: flex;\n                justify-content: flex-end;\n            }\n        }\n    }\n    \n}\n\n#fade-menu{\n    .menu-name{\n        padding: 6px 16px 10px;\n        border-bottom: 1px solid $border-grey-light;\n    }\n\n    li{\n        color: $font-secondary;\n        font-size: 14px;\n    }\n\n    li:hover{\n        color: inherit;\n    }\n}\n\na:active{\n    color: inherit;\n}\n\n.MuiGrid-container{\n    margin: auto;\n}  \n\n#admin-content{\n    padding: 32px 10px 0px 10px;\n\n    .MuiGrid-container{\n        padding: 0px 8px;\n    }\n\n    h1{\n        margin-top: 0px;\n        margin-bottom: 10px;\n    }\n\n    #admin-menu-left{\n        h3{\n            margin-top: 0px;\n            font-size: 16px;\n        }\n\n        .menu-links{\n            padding-bottom: 7px;\n\n            a{\n                font-family: AdminFontRegular;\n                color: $font-dark;\n                text-decoration: none;\n                font-size: 14px;\n                padding-top: 5px;\n                padding-left: 12px;\n                border-left: 1px solid $border-grey-light;\n                padding-bottom: 7px;\n            }\n\n            .active {\n                color: $font-secondary;\n                border-left: 2px solid $border-secondary;\n                font-family: AdminFontBold;\n            }\n        }\n    }\n\n    .MuiInputBase-input:focus{\n        color: $primary;\n    }\n}\n\nh1, h2, h3, h4, h5, h6{\n    font-family: AdminFontBold;\n}\n\nh1{\n    font-size: 28px;\n}\n\n.font-medium{\n    font-family: AdminFontMedium !important;\n}\n\n.font-bold{\n    font-family: AdminFontBold !important;\n}\n\n// Provisional\n#admin-content > div > div.MuiGrid-root.MuiGrid-item.MuiGrid-grid-xs-12.css-1idn90j-MuiGrid-root > div.MuiGrid-root.MuiGrid-container.MuiGrid-spacing-xs-1.css-17wqeb1-MuiGrid-root > div:nth-child(1) > div > a{\n    margin-top: 0px !important;\n}\n\n#prov-form{\n    font-size: 14px;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: space-between;\n    font-family: AdminFontRegular;\n\n    input, select, textarea{\n        font-size: 14px;\n        padding: 4px 8px;\n        border-radius: 6px;\n        border: 1px solid $border-grey-light;\n        font-family: AdminFontRegular;\n    }\n    input::placeholder{\n        font-size: 14px;\n    }\n    .mb-12{\n        margin-bottom: 12px;\n    }\n    h3{\n        font-size: 16px;\n    }\n    button{\n        padding: 8px 22px !important;\n        border: none;\n        background-color: $primary;\n        color: $font-light;\n        font-family: AdminFontBold;\n        border-radius: 6px !important;\n        cursor: pointer;\n    }\n    p{\n        font-family: AdminFontBold;\n        color: $font-grey;\n    }\n}\n\n.prov-form-select{\n    font-size: 16px;\n    padding: 4px 8px;\n    border-radius: 6px;\n    border: 1px solid $border-grey-light;\n    font-family: AdminFontMedium;\n}\n\n.prov-button-div{\n    display: flex;\n    flex-direction: row;\n    flex-wrap: nowrap;\n    align-items: center;\n    justify-content: center;\n\n    .prov-button{\n        padding: 8px 22px !important;\n        border: none;\n        background-color: $primary;\n        color: $font-light;\n        font-family: AdminFontBold;\n        border-radius: 6px !important;\n        cursor: pointer;\n    }\n}\n.MuiButton-containedPrimary{\n    background-color: $primary !important;\n}","$primary: rgb(80, 70, 228);\n$primaryOpacity: rgba(225, 221, 0, 0.2);\n\n$font-primary: #fff;\n$font-secondary: rgb(80, 70, 228);\n$font-light: #fff;\n$font-grey: #c9c9c9;\n$font-dark: #1A1B25;\n\n$border-secondary: #3e1952;\n$border-light: #fff;\n$border-grey-light: #eee;\n$border-grey: #c9c9c9;\n$boder-grey-dark: #444444;\n\n$background-secondary: #3e1952;\n$background-light: #fff;\n$background-grey-light: #F6F8FA;\n$background-grey: #a7a7a7;\n$background-grey-dark: #363636;\n$background-dark: #151515;\n$background-dark-absolute: #000;\n\n$success: #3edb93;\n$danger: #ff5a5f;\n",".css-1h9z7r5-MuiButtonBase-root-MuiTab-root.Mui-selected{\n    color: $font-secondary !important;\n}\n.css-1aquho2-MuiTabs-indicator{\n    background-color: $font-secondary !important;\n}",".css-1pe4mpk-MuiButtonBase-root-MuiIconButton-root.Mui-disabled {\n    opacity: 0.2;\n}\n\n.table-title {\n    font-size: 13px;\n    font-family: AdminFontRegular;\n}\n\n.pagination {\n    color: $font-dark;\n    width: 100%;\n    letter-spacing: 1px;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    flex-wrap: nowrap;\n    justify-content: space-between;\n    font-size: 14px;\n    font-family: AdminFontRegular;\n\n    p {\n        margin: 0px;\n    }\n\n    div {\n        display: flex;\n        align-items: center;\n    }\n\n    .pagination-buttons {\n        button {\n            font-family: AdminFontMedium;\n            border: 1px solid $border-grey;\n            background-color: $background-light;\n            border-radius: 6px;\n            padding: 6px 10px;\n            cursor: pointer;\n            letter-spacing: 1px;\n            color: $font-dark;\n        }\n\n        button:disabled {\n            color: $font-grey;\n            border: 1px solid $border-grey;\n            background-color: $background-light;\n            cursor: default;\n        }\n    }\n}",".MuiButton-contained.MuiButton-containedCancel {\n  background-color: #f5f5f5 !important; /* gris clar */\n  color: #333 !important; /* text gris fosc */\n  border: 1px solid #dcdbdc !important;\n  box-shadow: none !important;\n}\n@import \"./colors\";\n\n.box-default {\n  border: 1px solid #dcdbdc !important;\n  border-radius: 5px;\n}\n\n/* BUTTON PRIMARY */\n.MuiButton-containedPrimary {\n  padding: 8px 22px !important;\n  border-radius: 6px !important;\n  color: $font-primary !important;\n  background-color: $primary !important;\n  box-shadow: rgb(9 30 66 / 12%) 0px 1px 3px !important;\n}\n\n/* BUTTON SECONDARY */\n.MuiButton-textSecondary {\n  padding: 8px 22px !important;\n  border-radius: 6px !important;\n  color: rgba(0, 0, 0, 0.87) !important;\n  background-color: transparent !important;\n}\n\n/* checked */\n.MuiSwitch-colorPrimary.Mui-checked {\n  color: $primary !important;\n}\n\n.MuiSwitch-track {\n  background: $primary !important;\n}\n\n/* Link */\n.MuiTypography-colorPrimary {\n  color: $primary !important;\n}\n\n/* Menu */\n.MuiListItem-root.Mui-selected,\n.MuiListItem-root.Mui-selected:hover {\n  background: $primaryOpacity !important;\n}\n\n.MuiListItem-root.MuiListItem-gutters:active {\n  color: #000 !important;\n}\n\n.p-20 {\n  padding: 20px;\n}\n\n.p-0 {\n  padding: 0px !important;\n}\n\n.mt-0 {\n  margin-top: 0px !important;\n}\n\n.mr-5px {\n  margin-right: 5px;\n}\n\n.mt-2 {\n  margin-top: 20px !important;\n}\n\n.ml-2 {\n  margin-left: 20px;\n}\n\n.mr-2 {\n  margin-right: 20px;\n}\n\n.mb-2 {\n  margin-bottom: 20px !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.MuiTableCell-head {\n  font-size: 12px !important;\n}\n\n.alert-success {\n  background-color: $success;\n  padding: 20px;\n  margin-bottom: 20px;\n  border-radius: 6px !important;\n  color: #000;\n}\n\n.alert-danger {\n  background-color: $danger;\n  padding: 20px;\n  margin-bottom: 20px;\n  border-radius: 6px !important;\n  color: #000;\n}\n\na.MuiButtonBase-root:hover {\n  color: #000 !important;\n}\n\n/* DASH background */\n.css-fxbtpg{\n  background-color: #f5f4f9 !important;\n}\n\n/* DASH background */\n.css-fxbtpg{\n  background-color: #f5f4f9 !important;\n}\n",".dnd-element:first-child {\n  background: #929292 !important;\n}\n\n","/* TitTap Editor Design */\n.ProseMirror {\n  padding: 10px;\n  border-top: 1px solid grey;\n  background: white;\n  border-radius: 0 0 5px 5px;\n  min-height: 100px;\n}\n.ProseMirror:focus {\n  border: none;\n  outline: 1px solid aqua;\n}\n\n.ProseMirror > * + * {\n  margin-top: 0.75em;\n}\n\n.ProseMirror ul,\n.ProseMirror ol {\n  padding: 0 2rem;\n}\n\n.ProseMirror h1,\n.ProseMirror h2,\n.ProseMirror h3,\n.ProseMirror h4,\n.ProseMirror h5,\n.ProseMirror h6 {\n  line-height: 1.1;\n}\n\n.ProseMirror code {\n  background-color: rgba(#616161, 0.1);\n  color: #616161;\n}\n\n.ProseMirror pre {\n  background: #0d0d0d;\n  color: #fff;\n  font-family: \"JetBrainsMono\", monospace;\n  padding: 0.75rem 1rem;\n  border-radius: 0.5rem;\n}\n.ProseMirror code {\n  color: inherit;\n  padding: 0;\n  background: none;\n  font-size: 0.8rem;\n}\n\n.ProseMirror img {\n  max-width: 100%;\n  height: auto;\n}\n\n.ProseMirror blockquote {\n  padding-left: 1rem;\n  border-left: 3px solid #999999;\n}\n\n.ProseMirror hr {\n  border: none;\n  border-top: 3px solid #999999;\n  margin: 2rem 0;\n}\n\n/* ............................ */\n\n.menuBar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-top-right-radius: 10px;\n  border-top-left-radius: 10px;\n  border: 1px solid #bdbcbd;\n  border-bottom: 0px;\n}\n.menuBar button {\n  background-color: transparent;\n  border: none;\n  border-radius: 0.4rem;\n  color: #0d0d0d;\n  height: 1.75rem;\n  margin-right: 0.25rem;\n  padding: 0.25rem;\n  width: 1.75rem;\n  margin: 5px;\n}\n\n.menuBar button:hover {\n  background: #000;\n  color: #fff;\n}\n\n.heading3 {\n  font-size: 15px;\n}\n\nbutton.is_active {\n  background: #000;\n  color: #fff;\n}\n\n.menuBar .divider {\n  background-color: transparent;\n  border: none;\n  border-radius: 0.4rem;\n  color: #0d0d0d;\n  height: 1.75rem;\n  margin-right: 0.25rem;\n  padding: 0.25rem;\n  width: 1.75rem;\n  margin: 5px;\n}\n.ProseMirror{\n  border: none;\n}\n.ProseMirror:focus {\n  outline: 1px solid transparent;\n}\n","@import \"./colors\";\n\nh3.fields-title {\n  padding: 0px 0px 20px 0px;\n  margin: 0px 0px 20px 0px;\n  border-bottom: 1px solid $font-grey;\n  letter-spacing: 1px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
